import { render, staticRenderFns } from "./PaginationTableBody.vue?vue&type=template&id=cbf2c5a6&lang=pug&"
import script from "./PaginationTableBody.vue?vue&type=script&lang=js&"
export * from "./PaginationTableBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports